import { UserPreferences } from './preferences';

export enum Permissions {
    userManagement = 'userManagement',
    userManagement_deleteUser = 'userManagement_deleteUser',
    parcelSearch = 'parcelSearch',
    parcelSearch_extendedSearch = 'parcelSearch_extendedSearch',
    parcelSearch_deliveryPictures = 'parcelSearch_deliveryPictures',
    parcelSearch_deliveryPicturesIncludeAll = 'parcelSearch_deliveryPicturesIncludeAll',
    shippingPortal_returns = 'shippingPortal_returns',
    shippingPortal_transfers = 'shippingPortal_transfers',
    shippingPortal_outbound = 'shippingPortal_outbound',
    shippingPortal_unfilteredDestinations = 'shippingPortal_unfilteredDestinations',
    shippingPortal_importLabels = 'shippingPortal_importLabels',
    shipmentTracking = 'shipmentTracking',
    deliveryManagementTool = 'deliveryManagementTool',
    exportData = 'exportData',
    customerManagement = 'customerManagement',
    quickShip = 'quickShip',
    reports_all = 'reports_all',
    reportManagement = 'reportManagement',
}

export enum PermissionContext {
    GLOBAL,
    CUSTOMER,
    DEALER,
}

export const PermissionContextMapping: Record<Permissions, PermissionContext> =
    {
        [Permissions.userManagement]: PermissionContext.DEALER,
        [Permissions.userManagement_deleteUser]: PermissionContext.GLOBAL,
        [Permissions.parcelSearch]: PermissionContext.CUSTOMER,
        [Permissions.parcelSearch_extendedSearch]: PermissionContext.GLOBAL,
        [Permissions.parcelSearch_deliveryPictures]: PermissionContext.GLOBAL,
        [Permissions.parcelSearch_deliveryPicturesIncludeAll]:
            PermissionContext.GLOBAL,
        [Permissions.shippingPortal_returns]: PermissionContext.DEALER,
        [Permissions.shippingPortal_transfers]: PermissionContext.DEALER,
        [Permissions.shippingPortal_outbound]: PermissionContext.DEALER,
        [Permissions.shippingPortal_unfilteredDestinations]:
            PermissionContext.GLOBAL,
        [Permissions.shippingPortal_importLabels]: PermissionContext.GLOBAL,
        [Permissions.shipmentTracking]: PermissionContext.DEALER,
        [Permissions.deliveryManagementTool]: PermissionContext.GLOBAL,
        [Permissions.exportData]: PermissionContext.GLOBAL,
        [Permissions.reports_all]: PermissionContext.GLOBAL,
        [Permissions.customerManagement]: PermissionContext.GLOBAL,
        [Permissions.reportManagement]: PermissionContext.GLOBAL,
        [Permissions.quickShip]: PermissionContext.GLOBAL,
    };

export const REPORTS_PERMISSION_PREFIX = 'reports_' as const;
export type DynamicReportPermissionName =
    `${typeof REPORTS_PERMISSION_PREFIX}${string}`;

export type UserPermission = Partial<
    Record<Permissions | DynamicReportPermissionName, EntityAccess[] | boolean>
>;

export enum EntityType {
    CUSTOMER = 'customer',
    DEALER = 'dealer',
    ACCESS_ALL_CUSTOMERS = 'accessAllCustomers',
}

export type EntityAccess =
    | {
          type: EntityType.CUSTOMER | EntityType.DEALER;
          id: string;
      }
    | {
          type: EntityType.ACCESS_ALL_CUSTOMERS;
      };

export type FmtpUser = {
    userId: string;
    permissions: UserPermission;
    firstName: string;
    lastName: string;
    dateFrom: Date;
    dateUntil: Date | null;
    createdOn: Date;
    createdBy: string;
    modifiedOn: Date | null;
    modifiedBy: string | null;
    preferences?: Partial<UserPreferences>;
};

export type FmtpTransientStorageUser = {
    userId: string;
    permissions: UserPermission;
};

export type FmtpUserResponse = {
    username: string;
    id: string;
    email: string;
    enabled: boolean;
    firstName: string;
    lastName: string;
    permissions: UserPermission;
    createdBy: string;
    isFederated: boolean;
};
